/**
 * External dependencies
 */
import { filter, size } from 'lodash';

/**
 * Internal
 */
import { createReducer } from 'state/utils';
import * as actions from 'state/action-types';

export default createReducer([], {
	[actions.ADD_DASHBOARD_FILTER]: (state, action) => {
		return state;
	},
	[actions.REMOVE_DASHBOARD_FILTER]: (state, action) => {
		return state;
	},
	[actions.SET_DASHBOARD_FILTERS]: (state, action) => {
		// strip any filters that have empty "values"
		let filters = [...action.payload.filters];
		filters = filter(filters, (f) => size(f.values) >= 1);
		return filters;
	},
	[actions.RESET_DASHBOARD_FILTERS]: (state, action) => {
		return state;
	},
});
